import * as footerConstants from './actionTypes';
import {config} from '../../config/config';
import request from '../../components/Helper/Request';

const userDetails = JSON.parse(window.sessionStorage.getItem("userInfo"));

export const getFooterList = (limit,page) => {
    return (dispatch) => {
      dispatch({
        type: footerConstants.FETCH_FOOTER_LIST
      });

      request({
          method: 'get',
          url:`${config.API_URL}/api/email-section-configurations`,
          params: {
              limit,
              page,
              sortOrder : "desc",
              sortBy: "modifiedTime"
          }
      })
        .then((response) => { 
          dispatch({
            type: footerConstants.FETCH_FOOTER_LIST_SUCCESS,
            payload: response && response.filter(e=>e.sectionType==='FOOTER')
          });
        })
        .catch((error) => {
          dispatch({
            type: footerConstants.FETCH_FOOTER_LIST_FAILURE,
            payload:error
          });
        })
    }
  
}

export const createFooter =(footerData) =>{

    const data = {...footerData,  
      createdBy: userDetails?.emailId,
      modifiedBy: userDetails?.emailId
    }; 
    return (dispatch) => {
    dispatch({
        type: footerConstants.CREATE_FOOTER
    });

    request({
        method: 'post',
        url:`${config.API_URL}/api/email-section-configurations`,   
        data
    })
    .then((response) => {
        dispatch({
        type: footerConstants.CREATE_FOOTER_SUCCESS,
        payload: response
        });
    }).catch((error) => {
        dispatch({
        type: footerConstants.CREATE_FOOTER_FAILURE,
        payload:error?.response?.data
        });
    });
    }
}

export const editFooter =(footerData) =>{
        
  const data = {
    ...footerData,
    modifiedBy: userDetails?.emailId
  }; 

  return (dispatch) => {
  dispatch({
      type: footerConstants.EDIT_FOOTER
  });

  request({
      method: 'put',
      url:`${config.API_URL}/api/email-section-configurations/${data.code}`,   
      data
  })
  .then((response) => {
      dispatch({
      type: footerConstants.EDIT_FOOTER_SUCCESS,
      payload: response
      });
  }).catch((error) => {

      dispatch({
      type: footerConstants.EDIT_FOOTER_FAILURE,
      payload:error?.response?.data
      });
  });
  }
}

export const deleteFooter =(footerData) =>{
        
  const data = {
    ...footerData,
    modifiedBy: footerData?.modifiedBy
  }; 

  return (dispatch) => {
  dispatch({
      type: footerConstants.DELETE_FOOTER
  });

  request({
      method: 'delete',
      url:`${config.API_URL}/api/email-section-configurations/${data.code}`
  })
  .then(() => {
      dispatch({
      type: footerConstants.DELETE_FOOTER_SUCCESS,
      payload: {status: 1}
      });
  }).catch(() => {
      dispatch({
      type: footerConstants.DELETE_FOOTER_FAILURE,
      payload:{status: 0}
      });
  });
  }
}

export const resetEditFooterConfigData = () => {
return (dispatch) => {
  dispatch({
      type: footerConstants.RESET_EDIT_FOOTER_CONFIG_STATE
  });  
  }
}

export const resetCreateFooterConfigData = () => {
return (dispatch) => {
  dispatch({
      type: footerConstants.RESET_CREATE_FOOTER_CONFIG_STATE
  });  
  }
}